import { createRouter, createWebHistory } from 'vue-router'
import yxtIndex from '../views/yxt_index.vue' // 首页
import yxtIndexNew from '../views/yxt_index_new.vue' // 首页-新
import notFound from '../views/404.vue' // 404

import learnRoutes from "./modules/learning_center" // 学习中心
import aboutUsRoutes from "./modules/about_us" // 关于我们
import joinUsRoutes from "./modules/join_us" // 加入我们
import yxStudysRoutes from "./modules/yx_study" // 益学研究苑
import productRoutes from "./modules/product_center" // 产品中心
import vipRoutes from "./modules/vip_center" // 会员中心
import homeRoutes from "./modules/home" // 个人中心
import AIStockRoutes from "./modules/ai_stock" // AI选股
import H5Routes from "./modules/h5" // H5

const routes = [
  {
    path: '/',
    name: 'yxtIndex',
    component: yxtIndex,
    meta: {
      title: '益学堂-上海益学智迅科技发展有限公司',
    },
  },
  {
    path: '/yxtIndexNew',
    name: 'yxtIndexNew',
    component: yxtIndexNew,
    meta: {
      title: '益学堂-上海益学智迅科技发展有限公司',
    },
  },

  ...learnRoutes, // 学习中心
  ...aboutUsRoutes, // 关于我们
  ...joinUsRoutes, // 加入我们
  ...yxStudysRoutes, // 益学研究苑
  ...productRoutes, // 产品中心
  ...vipRoutes, // 会员中心
  ...homeRoutes, // 个人中心
  ...AIStockRoutes, // AI选股
  ...H5Routes, // H5

  {
    path: '/404',
    name: 'notFound1',
    component: notFound,
  },
  {
    path: '/:catchAll(.*)',
    name: 'notFound',
    component: notFound,
  },
  // {
  //   path: '/:catchAll(.*)',
  //   redirect: '/404'
  // },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 返回的对象将会被传递给 window.scrollTo 方法
    return { top: 0 };
  },
})

router.afterEach((to, from) => {
  if (to.name === 'notFound') {
    let currentUrl = encodeURIComponent(window.location.href);

    window.location.href = `/404?referer=${currentUrl}`; // 实际跳转，导致浏览器请求服务器上的/404
  }
});

router.beforeEach((to, from, next) => {
  // 从路由的 meta 信息中获取 title
  document.title = to.meta.title || '益学堂-上海益学智迅科技发展有限公司';
  next();
});

export default router
